__webpack_require__.p = "/punjabi-typing/_next/";